import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environment/environment';

export interface ServerConfig {
  apiServerHost: string;
  cognitoClientID: string;
  cognitoBaseUrl: string;
  cognitoLogoutUrl: string;
  osmApiUrl: string;
  osmBaseUrl: string;
}

@Injectable({
  providedIn: 'root'
})
export class RuntimeConfigService {
  private config: ServerConfig | null = null;
  private configLoaded = false;

  constructor(private http: HttpClient) {}

  /**
   * Load configuration from server-config.json
   * Falls back to environment settings if config file not available
   */
  async loadConfig(): Promise<void> {
    if (this.configLoaded) {
      return;
    }

    try {
      // Try to load server-config.json from assets
      const response = await this.http.get<ServerConfig>('/assets/server-config.generated.json').toPromise();
      if (response) {
        this.config = response;
        console.log('Server config loaded:', this.config);
      }
    } catch (error) {
      console.warn('Could not load server-config.json, using environment defaults', error);
      // Use environment defaults
      this.config = {
        apiServerHost: environment.baseUrl.replace('https://', '').split('/')[0],
        cognitoClientID: environment.cognitoConfig?.userPoolWebClientId || '',
        cognitoBaseUrl: '',
        cognitoLogoutUrl: '',
        osmApiUrl: environment.baseUrl,
        osmBaseUrl: ''
      };
    }

    this.configLoaded = true;
  }

  /**
   * Get the API URL - prefers server config, falls back to environment
   */
  get apiUrl(): string {
    if (this.config?.osmApiUrl) {
      return this.config.osmApiUrl;
    }
    return environment.baseUrl;
  }

  /**
   * Get the full server config
   */
  getConfig(): ServerConfig | null {
    return this.config;
  }
}

/**
 * Factory function for APP_INITIALIZER
 */
export function RuntimeConfigFactory(configService: RuntimeConfigService): () => Promise<void> {
  return () => configService.loadConfig();
}
